import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SITE } from "@/data/site";
import { CtaLink } from "@/components/common/Buttons";
import { Reveal } from "@/components/common/Reveal";

export const FinalCta = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [80, -80]);
  const r = useTransform(scrollYProgress, [0, 1], [-8, 8]);
  return (
    <section ref={ref} className="grain relative overflow-hidden bg-[#030712] py-28 text-white lg:py-36" data-testid="final-cta">
      <div className="grid-dark pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black_10%,transparent_70%)]" />
      <motion.img style={{ y, rotate: r }} src="/brand/mark-dark.webp" alt="" aria-hidden="true" loading="lazy"
        className="pointer-events-none absolute -right-16 top-[18%] w-[340px] opacity-25 sm:w-[480px] lg:right-10 lg:w-[560px]" />
      <div className="container-q relative">
        <Reveal><p className="eyebrow text-cyan-300">Start a project</p></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-4xl text-[2.4rem] font-extrabold leading-[1.02] tracking-[-0.04em] sm:text-6xl lg:text-7xl">
            Have a Product Idea or a <span className="grad-text">Business Challenge?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}><p className="mt-8 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg">Let's discuss your requirements and explore the right technical solution for your business.</p></Reveal>
        <Reveal delay={0.24} className="mt-10 flex flex-col gap-3 sm:flex-row">
          <CtaLink to="/contact" data-testid="final-cta-start">Start a Conversation</CtaLink>
          <CtaLink href={`mailto:${SITE.email}`} variant="ghostDark" arrow="right" data-testid="final-cta-email">Email Quantivo</CtaLink>
        </Reveal>
      </div>
    </section>
  );
};
